/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterRangeDecimal } from './filterRangeDecimal';
import { GlassesLimitsObjectV2 } from './glassesLimitsObjectV2';

export interface GlassesLimitsObjectV21 {
  endurance: FilterRangeDecimal;
  rarities: Array<GlassesLimitsObjectV2>;
  sorts: Array<string>;
}
